// extracted by mini-css-extract-plugin
export default {"container":"Gi-z","blurb":"Hi-z","links":"Ii-z"};